import Udesk from 'Udesk';
import React, { useCallback, useMemo } from 'react';
import { Template } from './normal';
import './style.scss';

export default React.memo((props) => {
    const { operatorItem, changeInputValue, disabled = false } = props;

    const changeHandle = useCallback(
        (v) => {
            changeInputValue(operatorItem, 'param', {
                target: { value: { defaultHit: v.defaultHit, type: operatorItem.operatorType } },
            });
            changeInputValue(operatorItem, 'keyword', v.keyword);
        },
        [changeInputValue, operatorItem]
    );

    const showDefaultHit = useMemo(() => {
        return [
            Udesk.enums.operatorTypes.videoFile.id,
            Udesk.enums.operatorTypes.voiceMessage.id,
            Udesk.enums.operatorTypes.picture.id,
            Udesk.enums.operatorTypes.document.id,
        ].includes(operatorItem.operatorType);
    }, [operatorItem.operatorType]);

    return (
        <Template
            {...{
                value: {
                    defaultHit: operatorItem.operatorList?.[0]?.param?.defaultHit,
                    keyword: operatorItem.operatorList?.[0]?.keyword,
                },
                onChange: changeHandle,
                disabled,
                showDefaultHit,
            }}
        />
    );
});
